import React from 'react';
import {
  FDBackButton, FDBox, FDIcon, FDStack, FDTooltip,
} from '@facet-wealth/design';
import ManagedAccountPortfolioPieChart
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/PortfolioSection/ManagedAccountPortfolioPieChart';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import ManagedAccountPortfolioBarChart
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/PortfolioSection/ManagedAccountPortfolioBarChart';
import useMobileLayout from 'Hooks/useMobileLayout';
import fr from 'facet-rest';
import {
  HoldingsSectionForScenarioSelectionModelUpdate,
} from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionRedefined/ScenarioSelectionModelDetailsStepTemplate/HoldingsSectionForScenarioSelectionModelUpdate';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';

const OutcomeInvestmentDetailsAccountDetailsSection = ({
  allocationMixChartData = [],
  tickerMixChartData = [],
  onBack = undefined,
}) => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  return (
    <FDBox {...dataAttrs('investment-details-account-details-section')}>
      <FDStack direction={isMobile ? 'column' : 'row'} justifyContent={'center'} alignItems={'center'} spacing={2} width={'100%'}>
        {!isMobile && (
        <FDBox height={250} width={250} flexShrink={0}>
          <ManagedAccountPortfolioPieChart
            allocationModelClassifications={allocationMixChartData}
            tickerClassifications={tickerMixChartData}
            isSimple
          />
        </FDBox>
        )}
        <FDStack direction={'column'} spacing={2} width={'100%'}>
          <FDStack spacing={2}>
            {onBack && (
            <FDBackButton onClick={onBack} {...dataAttrs('account-details-back-button')} />
            )}
            <MetaControlField attr={'title'} />
          </FDStack>
          <MetaControlField attr={'description'} />
        </FDStack>
        {isMobile && (
        <ManagedAccountPortfolioBarChart
          allocationModelClassifications={allocationMixChartData}
          simple
        />
        )}
      </FDStack>
      <FDStack direction={'column'} spacing={2} width={'100%'}>
        {resource.withRelationship(fr.relationships.equityHoldings.name,
          (rel) => (
            <HoldingsSectionForScenarioSelectionModelUpdate
              holdingsTypeLabel={resource.meta().field('equityHoldings').attr('prompt') || 'Equity Holdings'}
              holdingsPercentage={resource.attr('equityHoldings')}
              holdingsCollection={rel.getRelated()}
              color={'primary'}
            />
          ),
          () => null)}
        {resource.withRelationship(fr.relationships.alternativeIncomeHoldings.name,
          (rel) => (
            <HoldingsSectionForScenarioSelectionModelUpdate
              holdingsTypeLabel={resource.meta().field('alternativeIncomeHoldings').attr('prompt') || 'Alternative Income Holdings'}
              holdingsPercentage={resource.attr('alternativeIncomeHoldings')}
              holdingsCollection={rel.getRelated()}
              color={'purple'}
            />
          ),
          () => null)}
        {resource.withRelationship(fr.relationships.fixedHoldings.name,
          (rel) => (
            <HoldingsSectionForScenarioSelectionModelUpdate
              holdingsTypeLabel={resource.meta().field('fixedHoldings').attr('prompt') || 'Bond Holdings'}
              holdingsPercentage={resource.attr('fixedHoldings')}
              holdingsCollection={rel.getRelated()}
              color={'success'}
            />
          ),
          () => null)}
        <FDStack direction={'row'} spacing={1}>
          <MetaControlField attr={'expenseRatio'} />
          {resource.attr('expenseRatio') !== undefined && (
            <FDTooltip title={resource.attr('expenseRatioDescription')}>
              <FDIcon color={'primary'} icon={'info'} />
            </FDTooltip>
          )}
        </FDStack>
        <MetaControlField attr={'disclosure'} />
      </FDStack>
    </FDBox>
  );
};

export { OutcomeInvestmentDetailsAccountDetailsSection };
